import { Stack, Typography, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getPrescriptionsWithSites } from '../Common';

interface SimulationSubStepsProps {
  careplanId: string;
  isVisible: boolean;
  data?: any;
}

const getSiteGroupsFromPrescriptions = (prescriptions: any) => {
  return getPrescriptionsWithSites(prescriptions)
    ?.map((prescription: any) => prescription.sitegroupSet.filter((sitegroup: any) => sitegroup.siteSet.length > 0))
    .flat();
};

const SimulationSubSteps = ({ isVisible, data }: SimulationSubStepsProps): JSX.Element => {
  const theme = useTheme();
  const location = useLocation();

  // Parse the URL to get the siteGroupIdx
  const pathSegments = location.pathname.split('/');
  const simulationIndex = pathSegments.findIndex((segment) => segment === 'simulation');
  const siteGroupIdx =
    simulationIndex !== -1 && simulationIndex + 1 < pathSegments.length ? pathSegments[simulationIndex + 1] : undefined;

  if (!isVisible) {
    return <></>;
  }

  const siteGroups = getSiteGroupsFromPrescriptions(data?.prescriptionsByCareplan) || [];

  return (
    <>
      {siteGroups?.map((siteGroup: any, siteGroupIndex: number) => {
        const isActive = String(siteGroupIndex) === (siteGroupIdx || '0');
        const siteGroupName = (siteGroup?.siteSet?.map((site: any) => site.treatmentSite?.treatmentSite) || []).join(
          ', ',
        );

        return (
          <div key={siteGroup.id}>
            <Stack
              sx={{
                background: isActive ? theme.palette.action.focus : 'transparent',
                padding: '8px 16px',
              }}>
              <Typography
                variant="body1"
                color={isActive ? 'text.primary' : 'text.secondary'}
                data-testid={`simulation-substep-${siteGroup.id}${isActive ? '-active' : ''}`}
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'initial',
                }}>
                {siteGroupName || `Simulation ${siteGroupIndex + 1}`}
              </Typography>
            </Stack>
          </div>
        );
      })}
    </>
  );
};

export default SimulationSubSteps;
